import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";

export default function AdminMessages() {
  const [password, setPassword] = useState("");
  const [authed, setAuthed] = useState(false);

  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const totalPages = useMemo(() => Math.max(Math.ceil(total / pageSize), 1), [total, pageSize]);

  async function login(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const r = await fetch("/api/admin/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ password }),
      });
      if (!r.ok) throw new Error("Şifre hatalı veya yetkisiz.");
      setAuthed(true);
      setPassword("");
      setPage(1);
    } catch (err) {
      setError(err.message || "Giriş başarısız.");
    } finally {
      setLoading(false);
    }
  }

  async function fetchMessages(p = page, ps = pageSize) {
    setError("");
    setLoading(true);
    try {
      const r = await fetch(`/api/admin/messages?page=${p}&pageSize=${ps}`, {
        method: "GET",
        credentials: "include",
      });
      if (r.status === 401) {
        setAuthed(false);
        throw new Error("Oturum kapalı. Tekrar giriş yap.");
      }
      if (!r.ok) throw new Error("Mesajlar alınamadı.");
      const data = await r.json();
      setRows(data.rows || []);
      setTotal(data.total || 0);
    } catch (err) {
      setError(err.message || "Hata oluştu.");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (authed) fetchMessages(page, pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authed, page, pageSize]);

  async function logout() {
    await fetch("/api/admin/logout", { method: "POST", credentials: "include" });
    setAuthed(false);
    setRows([]);
    setTotal(0);
    setPage(1);
  }

  if (!authed) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 16 }}>
        <div style={{ width: "100%", maxWidth: 420, border: "1px solid #ddd", borderRadius: 16, padding: 16 }}>
          <h2 style={{ margin: 0 }}>Tomedyus Admin</h2>
          <p style={{ opacity: 0.7, marginTop: 8 }}>Mesajları görmek için şifre gir.</p>

          <form onSubmit={login} style={{ marginTop: 12, display: "grid", gap: 10 }}>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Admin şifresi"
              style={{ padding: 10, borderRadius: 12, border: "1px solid #ddd" }}
            />
            <button disabled={loading || !password} style={{ padding: 10, borderRadius: 12 }}>
              {loading ? "Giriş yapılıyor..." : "Giriş"}
            </button>
            {error ? <div style={{ color: "crimson" }}>{error}</div> : null}
          </form>
        </div>
      </div>
    );
  }

  return (
    <div style={{ padding: 16, maxWidth: 1100, margin: "0 auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
        <h2 style={{ margin: 0 }}>Mesajlar</h2>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <Link to="/tomedyus-admin/content">İçerik Yönetimi →</Link>
          <button onClick={() => fetchMessages(page, pageSize)} disabled={loading}>Yenile</button>
          <button onClick={logout}>Çıkış</button>
        </div>
      </div>

      <div style={{ marginTop: 12, display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
        <div style={{ opacity: 0.7 }}>
          Toplam: <b>{total}</b> — Sayfa: <b>{page}</b>/<b>{totalPages}</b>
        </div>

        <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ opacity: 0.7 }}>Sayfa boyutu</span>
          <select
            value={pageSize}
            onChange={(e) => {
              setPageSize(parseInt(e.target.value, 10));
              setPage(1);
            }}
          >
            {[10, 20, 50, 100].map((n) => (
              <option key={n} value={n}>{n}</option>
            ))}
          </select>
        </div>
      </div>

      {error ? <div style={{ color: "crimson", marginTop: 10 }}>{error}</div> : null}

      <div style={{ marginTop: 12, overflowX: "auto", border: "1px solid #ddd", borderRadius: 16 }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead style={{ background: "#f6f6f6" }}>
            <tr>
              <th style={{ textAlign: "left", padding: 10 }}>Tarih</th>
              <th style={{ textAlign: "left", padding: 10 }}>Ad</th>
              <th style={{ textAlign: "left", padding: 10 }}>E-posta</th>
              <th style={{ textAlign: "left", padding: 10 }}>Mesaj</th>
            </tr>
          </thead>
          <tbody>
            {!loading && rows.length === 0 ? (
              <tr><td colSpan={4} style={{ padding: 10, opacity: 0.7 }}>Kayıt yok.</td></tr>
            ) : null}

            {rows.map((x) => (
              <tr key={x.id} style={{ borderTop: "1px solid #eee" }}>
                <td style={{ padding: 10, whiteSpace: "nowrap" }}>{new Date(x.createdAt).toLocaleString()}</td>
                <td style={{ padding: 10, whiteSpace: "nowrap" }}>{x.name}</td>
                <td style={{ padding: 10, whiteSpace: "nowrap" }}>{x.email}</td>
                <td style={{ padding: 10 }}>{x.message}</td>
              </tr>
            ))}

            {loading ? (
              <tr><td colSpan={4} style={{ padding: 10, opacity: 0.7 }}>Yükleniyor…</td></tr>
            ) : null}
          </tbody>
        </table>
      </div>

      <div style={{ marginTop: 12, display: "flex", justifyContent: "space-between" }}>
        <button disabled={loading || page <= 1} onClick={() => setPage((p) => Math.max(p - 1, 1))}>
          ← Önceki
        </button>
        <button disabled={loading || page >= totalPages} onClick={() => setPage((p) => Math.min(p + 1, totalPages))}>
          Sonraki →
        </button>
      </div>
    </div>
  );
}
